module.exports = __webpack_public_path__ + "img/dummy0.01a1f73.jpg";